import { render } from "./VoiceAction.vue?vue&type=template&id=8afb1f80&scoped=true"
import script from "./VoiceAction.vue?vue&type=script&lang=js"
export * from "./VoiceAction.vue?vue&type=script&lang=js"

import "./VoiceAction.vue?vue&type=style&index=0&id=8afb1f80&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8afb1f80"]])

export default __exports__